import firestoreDB from '@/libs/firebase.init';
export default {
    namespaced: true,
    state: {
        callInfo: null,
    },
    getters: {
        getCallInfo: (state) => state.callInfo,
        isCallIncoming: (state) => state.callInfo !== null,
    },
    mutations: {
        storedCallInfo(state, doc) {
            state.callInfo = doc;

        },
    },
    actions: {
        setCallInfo({commit}, call_info) {
            commit('storedCallInfo', call_info);
        },
        initializeFirebaseListener({commit}, user_code) {
            firestoreDB.collection('doctorcall')
                .doc(user_code)
                .onSnapshot(doc => {
                    console.log(doc.exists);
                    if (doc.exists) {
                        commit('storedCallInfo', doc.data())
                    }
                })
        },

    },
};
